import { array, bool, func, object, string } from 'prop-types';
import useTabs from '../hooks/useTabs';
import TabHeader from './TabHeader';
import TabList from './TabList';
import TabButtons from './TabButtons';
import Collapse from '@mui/material/Collapse';
import sty from '../styles/Tabs.module.css';
import MenuModal from './MenuModal';
import LoadingBackdrop from 'components/LoadingBackdrop';

/**
 * @component Tabs
 * @param { Object } props
 * @param { boolean } props.open
 * @param { boolean } props.trgRst
 * @param { object } props.savingState
 * @param { object } props.savingHandler
 * @param { string } props.groupId
 * @param { array } props.selectedTabs
 * @param { array } props.tabs
 * @param { function } props.onMenu
 * @returns { JSX.Element }
 */
function Tabs(props) {
	const { state, handler, handleSubtab } = useTabs(props);

	return (
		<Collapse className={sty.tabs_collapse} in={props.open} timeout="auto" unmountOnExit>
			<section className={sty.tabs_section}>
				<TabHeader
					options={state.filteredTabs}
					isDisabled={state.isDisabled}
					selected={state.chosenOptions}
					onOptions={handler.onOptions}
					onAdd={handler.onAdd}
					onDelete={handler.onDelete}
				/>
				<TabList
					groupId={props.groupId}
					savingState={props.savingState}
					savingHandler={props.savingHandler}
					tabs={props.tabs}
					isCheckAll={state.isCheckAll}
					groupTabs={state.groupTabs}
					onCheck={handler.onCheck}
					onCheckAll={handler.onCheckAll}
					onHandle={handler.onHandle}
					onSetTabs={handler.onSetTabs}
					onToggle={handler.onToggle}
					onMenu={props.onMenu}
					handleSubtab={handleSubtab}
				/>
				<TabButtons
					onSave={handler.onSave}
					onReset={handler.onReset}
					onCreate={handler.onCreate}
					isOpenSubtab={state.isOpenSubtab}
				/>
			</section>
			{handleSubtab.modal && (
				<MenuModal
					open={handleSubtab.modal}
					onClose={handleSubtab.onCloseModal}
					onSave={handleSubtab.onSaveSubtab}
				/>
			)}
			<LoadingBackdrop open={state.loading} />
		</Collapse>
	);
}

Tabs.propTypes = {
	open: bool,
	trgRst: bool,
	savingState: object,
	savingHandler: object,
	groupId: string,
	selectedTabs: array,
	tabs: array,
	onMenu: func,
};

export default Tabs;
